"use client";

import { useEffect } from "react";

import { ga4PageNotFound } from "@/lib/analytics/ga4-ecommerce";

export default function Ga4NotFoundTracker() {
	useEffect(() => {
		ga4PageNotFound();
	}, []);

	return null;
}
